import React from "react";
import ClubMembers from "../ClubMembers";

const Member = () => {
  return (
    <div className="mt-16">
      <div className=" mx-auto max-w-4xl flex flex-wrap justify-center">
        <ClubMembers name="Гансүх Болормаа" dep="CS1A" />
        <ClubMembers name="Гансүх Болормаа" dep="CS1A" />
        <ClubMembers name="Гансүх Болормаа" dep="CS1A" />
        <ClubMembers name="Гансүх Болормаа" dep="CS1A" />
        <ClubMembers name="Гансүх Болормаа" dep="CS1A" />
        <ClubMembers name="Гансүх Болормаа" dep="CS1A" />
        <ClubMembers name="Гансүх Болормаа" dep="CS1A" />
        <ClubMembers name="Гансүх Болормаа" dep="CS1A" />
      </div>
    </div>
  );
};
export default Member;
